import React from 'react';
import { Step, StepLabel } from '@mui/material';
import {
  StepperComponentWrapper,
  StyledStepper,
  StepTitle,
  StyledStepperLabel,
} from './styles';
import { StepIcon } from '../StepIcon';

export const StepperComponent = ({ steps, activeStep, hideLabel }) => {
  return (
    <StepperComponentWrapper
      data-testid='stepper-component'>
      <StyledStepper
        activeStep={activeStep} alternativeLabel>
        {steps
          .filter((step) => Boolean(!step.hideLabel))
          .map((step) => (
            <Step
              key={step.key}>
              <StyledStepperLabel
                data-testid='styled-stepper-label' StepIconComponent={StepIcon}>
                {step.label}
              </StyledStepperLabel>
            </Step>
          ))}
      </StyledStepper>
      <StepTitle>{steps[activeStep].label}</StepTitle>
    </StepperComponentWrapper>
  );
};
